import React from 'react'
import { useRouter } from 'next/router'

const Error = () => {
  const router = useRouter()
  const requestCameFrom = router.query.camefrom

  return (
    <div>
      <h5>Page Not Found</h5>
      <p>This page does not exist. Please double-check the URL and try again.</p>
      <button onClick={() => router.push(requestCameFrom ? `/?camefrom=${requestCameFrom}` : '/')}>Go Back to Home</button>
    </div>
  )
}

Error.propTypes = {}

export default Error
